import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Text } from 'components/common/form';

const CertificatesCreate = connect((state) => state)(
  class extends Component {
    handleModalVisible = () => {
      this.titleInputContainer.querySelector('input').focus();
    };

    submit = async (values) => {
      const { dispatch, messages, updateTemplates } = this.props;

      const response = await api.post('/admin/certificate-templates', {
        title: values.title
      });
      await updateTemplates();
      dispatch(
        actions.addNotice({
          text: messages.siteCertificatesAddSuccess,
          type: 'success'
        })
      );
    };

    render() {
      const { messages } = this.props;
      return (
        <ModalButtonWithForm
          buttonCategory="success"
          buttonIcon="plus"
          buttonText={messages.siteCertificatesAdd}
          modalActionText={messages.commonAdd}
          modalTitle={messages.siteCertificatesAdd}
          onModalVisible={this.handleModalVisible}
          onSubmit={this.submit}
          pristineIsValid={false}
        >
          {(formState) => (
            <FormGroup htmlFor="title" label={messages.commonTitle}>
              <Text
                field="title"
                id="title"
                inputContainerRef={(el) => (this.titleInputContainer = el)}
              />
            </FormGroup>
          )}
        </ModalButtonWithForm>
      );
    }
  }
);

export default CertificatesCreate;
